import { compose, lifecycle, withState } from 'recompose'
import withType from 'components/common/hoc/withType'
import { generateItemListElement } from 'helpers/SEOSchema'
import BreadcrumbLink from './BreadcrumbLink'

const withBreadcrumbListSchema = withState('breadcrumbListSchema', 'setBreadcrumbListSchema', {})

const withBreadcrumbsLifecycle = lifecycle({
  componentDidMount() {
    const {
      links = [],
      setBreadcrumbListSchema
    } = this.props

    setBreadcrumbListSchema({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: generateItemListElement(links)
    })
  }
})

export default compose(
  withType({
    type: [
      'BOTBreadcrumbLink',
      'BOTBreadcrumbLink',
      'BOTBrandBreadcrumbLink',
      'BOTTireLineBreadcrumbLink',
      'BOTProductBreadcrumbLink',
      'BOTSearchResultBreadcrumbLink'
    ],
    placeholders: ['links']}),
  withBreadcrumbListSchema,
  withBreadcrumbsLifecycle
)(BreadcrumbLink)
